/**
 * 产品服务风险声明
 */
import { RouterV2Enum } from '@/router/router-names';
import { EvokeAppTypeEnums } from '@/views_v2/new-redirect/types';
import { Vue, Component, Prop } from 'vue-property-decorator';

import style from './index.module.scss';

@Component
export default class RiskStatement extends Vue {
  @Prop({ default: true })
  private sence!: boolean

  /** 风险文案-关联app类型 */
  @Prop(String) readonly relateAppType!: EvokeAppTypeEnums;

  private render() {
    return (
      <div class={[
        style.riskStatementContainer,
        !this.sence && style.myPage,
        this.$route.path === RouterV2Enum.taglessAliminiHome && style.beforeCredit,
        this.relateAppType && style[this.relateAppType],
      ]}>
        <div class={style.slogan} />
        {this.sence && (
          <div class={style.statement}>
            <div class={style.content}>
              贷款有风险，借款需谨慎，请根据个人能力合理贷款，理性消费，避免逾期贷款额度、放款时间以实际审批结果为准
            </div>
          </div>
        )}
      </div>
    );
  }
}
